<template>
  <div class="mb-8">
    <v-card class="mx-auto mb-3">
      <div id="filters">
        <template>
          <v-toolbar flat>
            <v-toolbar-title>
              <p class="mb-0">{{ $t("APPROVAL_RULES") }}</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-form ref="filterForm">
            <v-container>
              <v-row>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12">
                  <v-select
                      v-model="filterItems.yearId"
                      :item-text="y => $t(y.name)"
                      :items="years"
                      :label="$t('ACADEMIC_YEAR')"
                      item-value="id"
                      outlined
                      @change="changeYear"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12">
                  <v-select
                      v-model="filterItems.semesterId"
                      :item-text="y => serverTranslate(y.name)"
                      :items="semesters"
                      :label="$t('ACADEMIC_SEMESTER')"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions class="px-4">
              <v-container class="px-0">
                <v-row>
                  <v-col class="pa-1" cols="auto">

                    <v-btn
                        :fab="!$vuetify.breakpoint.mdAndUp"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        class="mx-2"
                        color="primary"
                        @click="showScopeTreeFn()">
                      <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('SCOPE') }}</span>
                      <v-icon :right="$vuetify.breakpoint.mdAndUp">mdi-navigation</v-icon>
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col class="pa-1" cols="auto">
                    <v-btn
                        :fab="!$vuetify.breakpoint.mdAndUp"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        color="primary" dark @click="searchApprovalRules"
                    >
                      <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t("SEARCH") }}</span>
                      <v-icon :right="$vuetify.breakpoint.mdAndUp">mdi-account-search</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col class="pa-1 mx-2" cols="auto">
                    <v-btn
                        :fab="!$vuetify.breakpoint.mdAndUp"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        class="white--text"
                        color="darken3"
                        @click="resetFilters"
                    >
                      <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t("RESET") }}</span>
                      <v-icon :right="$vuetify.breakpoint.mdAndUp">mdi-delete-empty</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-form>
        </template>
      </div>
    </v-card>
    <v-card class="mx-auto" outlined>
      <div id="inspire">
        <v-data-table
            :footer-props="{
         showFirstLastPage: true,
         firstIcon: 'mdi-arrow-collapse-left',
         lastIcon: 'mdi-arrow-collapse-right',
         prevIcon: 'mdi-arrow-left',
         nextIcon: 'mdi-arrow-right',
         itemsPerPageOptions: [ 20, 30, 50, 100]
         }"
            :headers="headers"
            :hide-default-footer="approvalRules.length <= 0"
            :item-class="rowClass"
            :items="approvalRules"
            :items-per-page="20"
            :loading="loading"
            class="elevation-1"
        >
          <template v-slot:item.facultyName="{ item }">
            {{ serverTranslate(item.facultyName) }}
          </template>
          <template v-slot:item.certificateName="{ item }">
            {{ serverTranslate(item.certificateName) }}
          </template>

          <template v-slot:item.allowedTotalDegree="{ item }">
             <span v-if="item.id && !item.editable">
                  {{ item.allowedTotalDegree }}
            </span>
            <!-- لو جديد -->
            <v-text-field
                v-else
                v-model="item.allowedTotalDegree"
                :rules="totalRules"
                dense
                hide-details="auto"
                outlined
                @keydown="allowOnlyDigits($event, item, 'allowedTotalDegree')"
                @paste="blockPaste"
                @drop.prevent
            />
          </template>

          <template v-slot:item.allowedStudentCount="{ item }">
            <span v-if="item.id && !item.editable">
              {{ item.allowedStudentCount }}
            </span>
            <v-text-field
                v-else
                v-model="item.allowedStudentCount"
                :rules="studentsNumbersRules"
                dense
                hide-details="auto"
                outlined
                type="number"
                @input="sanitizeDigits(item, 'allowedStudentCount')"
                @keydown="allowOnlyDigits"
                @paste="blockPaste"
                @drop.prevent
            />
          </template>

          <template >
            {{ $t('LARGEST_TOTAL') }}{{ $t('THEN') }}{{ $t('FIRST_APPLY') }}
          </template>

          <template v-slot:item.actions="{ item }">

            <!-- VIEW BRANCHES -->
            <v-tooltip v-if="item.studentsInBranches.length" top>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="showBranchsTotalCount(item)" v-on="on">
                  <v-icon class="mx-2" color="primary">mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("STUDENTS_COUNT_IN_BRANCH") }}</span>
            </v-tooltip>

            <!-- EDIT (only when NOT editing) -->
            <template
                v-if="item.facultyActivation === 1
                        && item.id
                        && !item.editable
                        && item.yearId === activeAcademicYear.id
                        && item.semesterId === activeAcademicSemester.id"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="editApprovalRule(item)" v-on="on">
                    <v-icon class="mx-2">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("EDIT") }}</span>
              </v-tooltip>
            </template>

            <!-- SAVE (only when editing) -->
            <template v-if="item.editable || !item.id">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="save(item)" v-on="on">
                    <v-icon color="primary">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("SAVE") }}</span>
              </v-tooltip>
            </template>

            <!-- CANCEL (only when editing) -->
            <template v-if="item.editable">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="cancelEdit(item)" v-on="on">
                    <v-icon color="grey">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("CANCEL") }}</span>
              </v-tooltip>
            </template>

          </template>


          <template v-slot:no-data>
            <v-alert class="mt-2" color="light5" icon="warning">
              {{ $t("NO_DATA") }}
            </v-alert>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-item v-html="gridTitle"></v-toolbar-item>
            </v-toolbar>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <pr-confirmDialog ref="confirm"></pr-confirmDialog>

    <!-- add new rule -->
    <!--    <v-dialog-->
    <!--        v-model="dialog"-->
    <!--        max-width="90vh"-->
    <!--        @keydown.esc="reset()"-->
    <!--        @click:outside="reset()"-->
    <!--    >-->
    <!--      <v-card outlined>-->

    <!--        <v-form ref="form" v-model="valid" lazy-validation>-->
    <!--          <v-card-title class="justify-center">-->
    <!--         <span class="headline black&#45;&#45;text text-thin">{{-->
    <!--             $t(formTitle)-->
    <!--           }}</span>-->
    <!--          </v-card-title>-->

    <!--          <v-card-text>-->
    <!--            <v-container>-->
    <!--              <v-alert v-show="showAlert" outlined type="error">-->
    <!--                {{ serverTranslate(errorMessages) }}-->
    <!--              </v-alert>-->
    <!--              <v-row>-->
    <!--                <v-col cols="6">-->
    <!--                  {{ $t("ACADEMIC_YEAR") }} :-->
    <!--                  <v-chip class="ma-2" color="dark" dark>-->
    <!--                    {{ serverTranslate(filterItems.yearName || "") }}-->
    <!--                  </v-chip>-->
    <!--                </v-col>-->
    <!--                <v-col cols="6">-->
    <!--                  {{ $t("ACADEMIC_SEMESTER") }} :-->
    <!--                  <v-chip class="ma-2" color="dark" dark>-->
    <!--                    {{ serverTranslate(filterItems.semesterName || "") }}-->
    <!--                  </v-chip>-->
    <!--                </v-col>-->
    <!--              </v-row>-->
    <!--              <v-row>-->
    <!--                <v-col cols="12">-->
    <!--                  <v-select-->
    <!--                      v-if="isAddEvent"-->
    <!--                      ref="faculty"-->
    <!--                      v-model="facultyId"-->
    <!--                      :items="serverTranslateArray(faculties, 'name')"-->
    <!--                      :label="$t('FACULTY')"-->
    <!--                      :rules="requiredRules"-->
    <!--                      item-text="name"-->
    <!--                      item-value="id"-->
    <!--                      required-->
    <!--                      @change="-->
    <!--                  branchesNumbers = [];-->
    <!--                  branchesNumbersModel = [];-->
    <!--                  "-->
    <!--                      @keydown.space="preventLeadingSpace"-->
    <!--                  ></v-select>-->
    <!--                  <v-chip v-else label>-->
    <!--                    {{ serverTranslate(facultyName) }}-->
    <!--                  </v-chip>-->
    <!--                </v-col>-->

    <!--                <v-col cols="12">-->
    <!--                  <v-select-->
    <!--                      v-if="isAddEvent"-->
    <!--                      ref="faculty"-->
    <!--                      v-model="certificateId"-->
    <!--                      :items="serverTranslateArray(CertificateBasicTypes, 'name')"-->
    <!--                      :label="$t('CERTIFICATE_TYPE')"-->
    <!--                      :rules="requiredRules"-->
    <!--                      item-text="name"-->
    <!--                      item-value="admissionId"-->
    <!--                      required-->
    <!--                      @change="-->
    <!--                  branchesNumbers = [];-->
    <!--                  branchesNumbersModel = [];-->
    <!--                  "-->
    <!--                      @keydown.space="preventLeadingSpace"-->
    <!--                  ></v-select>-->
    <!--                  <v-chip v-else label>-->
    <!--                    {{ serverTranslate(certificateName) }}-->
    <!--                  </v-chip>-->
    <!--                </v-col>-->

    <!--                <v-col cols="12">-->
    <!--                  <v-text-field-->
    <!--                      ref="totalDegree"-->
    <!--                      v-model="totalDegree"-->
    <!--                      :label="$t('MINIMUM_TOTAL_DEGREE')"-->
    <!--                      :rules="totalRules"-->
    <!--                      clearable-->
    <!--                      @input="totalDegree = parseFloat($event) || null"-->
    <!--                  />-->
    <!--                </v-col>-->

    <!--                <v-col cols="12">-->
    <!--                  <v-text-field-->
    <!--                      v-if="checkBranches"-->
    <!--                      ref="studentsNumbersTotal"-->
    <!--                      v-model="studentsCount"-->
    <!--                      :disabled="checkBranches"-->
    <!--                      :label="$t('STUDENTS_NUMBERS')"-->
    <!--                      :rules="studentsNumbersRules"-->
    <!--                      clearable-->
    <!--                      @input="studentsNumbers = parseInt($event) || null"-->
    <!--                  />-->
    <!--                  <v-text-field-->
    <!--                      v-else-->
    <!--                      v-model="studentsCount"-->
    <!--                      :label="$t('STUDENTS_NUMBERS')"-->
    <!--                      :rules="studentsNumbersRules"-->
    <!--                      clearable-->
    <!--                  />-->
    <!--                </v-col>-->
    <!--              </v-row>-->
    <!--              <v-row v-if="isAddEvent">-->
    <!--                <v-col-->
    <!--                    v-for="(branch, index) in branchesComputed"-->
    <!--                    v-bind:key="index"-->
    <!--                    cols="12"-->
    <!--                >-->
    <!--                  <v-text-field-->
    <!--                      :ref="'branchesNumbers_' + branch.id"-->
    <!--                      v-model="branchesNumbersModel[branch.id]"-->
    <!--                      :label="-->
    <!--               $t('STUDENTS_NUMBERS_FOR') + serverTranslate(branch.name)-->
    <!--               "-->
    <!--                      :rules="branchesNumbersRules"-->
    <!--                      clearable-->
    <!--                      @input="updateBranchesNumbers(branch.id, $event)"-->
    <!--                  />-->
    <!--                </v-col>-->
    <!--              </v-row>-->
    <!--              <v-row v-if="!isAddEvent">-->
    <!--                <v-col-->
    <!--                    v-for="(item,index) in editRule.studentsInBranches"-->
    <!--                    v-bind:key="index"-->
    <!--                    cols="12"-->
    <!--                >-->
    <!--                  <v-text-field-->
    <!--                      :ref="'editBranchesNumbers_' + item.branchId"-->
    <!--                      v-model="item.studentsNumbers"-->
    <!--                      :label="-->
    <!--            $t('STUDENTS_NUMBERS_FOR') + serverTranslate(item.branchName)-->
    <!--            "-->
    <!--                      :rules="branchesNumbersRules"-->
    <!--                      clearable-->
    <!--                  />-->
    <!--                </v-col>-->
    <!--              </v-row>-->
    <!--              <v-row>-->
    <!--                <v-col cols="12">-->
    <!--                  {{ $t('PERIORITY') }}:-->
    <!--                  <v-radio-group-->
    <!--                      v-model="priorityCheck"-->
    <!--                      :rules="requiredRules"-->
    <!--                      column>-->
    <!--                    <v-radio-->
    <!--                        :label="$t('LARGEST_TOTAL')"-->
    <!--                        color="blue"-->
    <!--                        value=1-->
    <!--                    ></v-radio>-->
    <!--                    <v-radio-->
    <!--                        :label="$t('FIRST_APPLY')"-->
    <!--                        color="blue"-->
    <!--                        value=0-->
    <!--                    ></v-radio>-->
    <!--                  </v-radio-group>-->
    <!--                </v-col>-->
    <!--              </v-row>-->
    <!--            </v-container>-->
    <!--          </v-card-text>-->

    <!--          <v-card-actions>-->
    <!--            <v-spacer></v-spacer>-->
    <!--            <v-btn color="primary" dark @click="save">{{ $t("SAVE") }}</v-btn>-->
    <!--            <v-btn class="white&#45;&#45;text" color="darken3" @click="reset()">-->
    <!--              {{ $t("CANCEL") }}-->
    <!--            </v-btn>-->
    <!--          </v-card-actions>-->
    <!--        </v-form>-->
    <!--      </v-card>-->
    <!--    </v-dialog>-->


    <pr-scope
        v-if="showScopeTree == true"
        :key="componentKey"
        :scopeFullPath="false"
        v-on:setScope="onScopeChanged"
    />
    <pr-students-branches-dialog
        v-if="showBranchesCount"
        :key="branchKey"
        :branches="studentsInBranches"
        :faculty="faculty"
    />
  </div>
</template>

<script>
import serverTranslations from "@/mixins/serverTranslations";
import scope from "@/components/shared/ScopeTree.vue";
import branchesDialog from "./BranchesDialog.vue";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import globalMethods from "@/mixins/globalMethods";

export default {
  name: "List",
  components: {
    "pr-scope": scope,
    "pr-students-branches-dialog": branchesDialog,
    "pr-confirmDialog": ConfirmDialog
  },
  mixins: [serverTranslations, globalMethods],
  mounted() {
    this.getApprovalRules().then(() => {
      this.normalizeApprovalRules()
    })
  },
  computed: {
    studentsNumbers() {
      let total = 0;
      if (!this.isAddEvent && this.editRule.studentsInBranches && this.checkBranches) {
        this.editRule.studentsInBranches.forEach(item => {
          item.studentsNumbers = item.studentsNumbers ? item.studentsNumbers : 0;
          total += parseInt(item.studentsNumbers);
          item.studentsNumbers = item.studentsNumbers ? item.studentsNumbers : '';
        });
      } else if (this.isAddEvent && this.branchesNumbersModel && this.checkBranches) {
        this.branchesNumbersModel.forEach(item => {
          item = item ? item : 0;
          total += parseInt(item);
        });
      } else if (!this.checkBranches) {

        total = this.studentsNumbers


      }
      return total;
    },
    locale() {
      return this.$store.curLanguage;
    },
    activeAcademicYear() {
      return this.$store.getters.getActiveAcademicYear;
    },
    activeAcademicSemester() {
      return this.$store.getters.getActiveAcademicSemester;
    },
    gridTitle() {
      const year = this.serverTranslate(this.filterItems.yearName ?? "");
      const semester = this.serverTranslate(
          this.filterItems.semesterName ?? ""
      );

      return this.$t("APPROVAL_RULES_GRID_TITLE", {
        year: `<bdi>${year}</bdi>`,
        semester
      });
    },
    formTitle() {
      return this.isAddEvent ? "ADD_APPROVAL_RULE" : "EDIT_APPROVAL_RULE";
    },
    headers() {
      return [
        {
          text: this.$t("FACULTY"),
          align: "center",
          sortable: true,
          value: "facultyName",
          width: "20%"
        },
        {
          text: this.$t("TOTAL_DEGREE"),
          align: "center",
          sortable: true,
          value: "allowedTotalDegree",
          width: "20%"
        },
        {
          text: this.$t("CERTIFICATE_TYPE"),
          align: "center",
          sortable: true,
          value: "certificateName",
          width: "20%"
        }, {
          text: this.$t("STUDENTS_NUMBERS"),
          align: "center",
          sortable: true,
          value: "allowedStudentCount",
          width: "10%"
        },
        {
          text: this.$t("PERIORITY"),
          align: "center",
          sortable: true,
          value: "priorityCheck",
          width: "10%"
        },
        // {
        //   text: this.$t("RECOMMENDED_ACCEPTED"),
        //   align: "center",
        //   sortable: true,
        //   value: "recommendedAccepted",
        //   width: "10%"
        // },
        // {
        //   text: this.$t("RECOMMENDED_REFUSED"),
        //   align: "center",
        //   sortable: true,
        //   value: "recommendedRefused"
        // },
        {
          text: this.$t("RULE_APPLY_DATE"),
          align: "center",
          value: "ruleApplyDate",
          sortable: false,
        },
        {
          text: this.$t("ACTIONS"),
          value: "actions",
          sortable: false,
          width: "20%"
        }
      ];
    },
    cannotAddNewRule() {
      const activeSemesters = this.semesters.filter(
          semester => parseInt(semester.active) === 1
      );
      return !(activeSemesters.length > 0);
    },
    branchesComputed() {
      return this.branches.filter(
          branch => branch.faculty_id === this.facultyId
      );
    }
  },

  data() {
    return {
      priorityCheck: "1",
      total: 0,
      valid: true,
      dialog: false,
      loading: false,
      checkBranches: true,
      showAlert: false,
      errorMessages: "",
      filterItems: {
        facultyId: 0,
        yearId: 0,
        yearName: "",
        semesterId: 0,
        semesterName: ""
      },
      semesters: [],
      years: [],
      scopes: [],
      faculties: [],
      CertificateBasicTypes: [],
      branches: [],/*Contains all define branches categorized by faculty_id*/
      approvalRules: [],/*all defined rules with student numbers in each branch*/
      editRule: {},
      currentYear: {},
      currentSemester: {},
      facultyId: 0,
      certificateId: 0,
      facultyName: "",
      certificateName: "",
      universityId: 0,
      totalDegree: null,
      studentsCount: null,
      // studentsNumbers: null,
      branchesNumbers: [],
      branchesNumbersModel: [],
      yearId: 0,
      yearName: "",
      semesterId: 0,
      semesterName: "",
      isAddEvent: true,
      requiredRules: this.$store.state.Rules.requiredRules,
      studentsNumbersRules: this.$store.state.Rules.studentsNumbersRules,
      totalRules: this.$store.state.Rules.totalRules,
      branchesNumbersRules: [
        v => this.isNotEmpty(v) || this.$t("REQUIRED_FIELD"),
        v =>
            this.isNotEmpty(v)
                ? /^(?:[1-9]\d*|0)?(?:\d+)?$/.test(v) || this.$t("INT_NUMBER_FIELD")
                : true,
        v => {
          if (this.isNotEmpty(v)) {
            let branchesNumbers = 0;

            this.branchesNumbers.forEach(branch => {
              branchesNumbers += parseInt(branch.studentsNumbers) || 0;
            });
            return (
                this.studentsNumbers >= branchesNumbers ||
                this.$t("BRANCHES_NUMBERS_MAX")
            );
          }
          return true;
        }
      ],


      showScopeTree: false,
      componentKey: 0,
      branchKey: 0,
      showBranchesCount: false,
      studentsInBranches: [],
      faculty: ""
    };
  },

  methods: {

    allowOnlyDigits(e, item, field) {
      const allowedKeys = [
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
      ]

      // السماح بالمفاتيح الأساسية
      if (allowedKeys.includes(e.key)) return

      const value = item[field] ? item[field].toString() : ''

      // السماح بالأرقام
      if (/^\d$/.test(e.key)) return

      // السماح بنقطة واحدة فقط (مش في الأول)
      if (e.key === '.') {
        if (value === '' || value.includes('.')) {
          e.preventDefault()
        }
        return
      }

      // منع أي شيء غير ذلك
      e.preventDefault()
    }
    ,

    sanitizeDigits(item, field) {
      if (!item[field]) return
      item[field] = item[field].toString().replace(/[^0-9]/g, '')
    },

    blockPaste(e) {
      e.preventDefault()
    },


    scrollToRow() {
      this.$nextTick(() => {
        const el = document.querySelector('.editing-row')
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
      })
    }
    ,
    normalizeApprovalRules() {
      if (this.approvalRules && this.approvalRules.length) {
        this.approvalRules.forEach(item => {
          if (item.editable === undefined) {
            this.$set(item, 'editable', false)
          }

          if (item.__backup === undefined) {
            this.$set(item, '__backup', null)
          }

          if (item._errors === undefined) {
            this.$set(item, '_errors', {
              allowedTotalDegree: null,
              allowedStudentCount: null
            })
          }
        })
      }
    }
    ,

    cancelEdit(item) {
      if (item.__backup) {
        item.allowedTotalDegree = item.__backup.allowedTotalDegree
        item.allowedStudentCount = item.__backup.allowedStudentCount
      }

      item.__backup = null
      item.editable = false
    }
    ,
    rowClass(item) {
      return item.editable ? 'editing-row' : ''
    },

    updateBranchesNumbers(branchId, $event) {
      const index = this.branchesNumbers.findIndex(
          branch => branch.branchId === branchId
      );
      if (index === -1) {
        this.branchesNumbers.push({
          branchId: branchId,
          studentsNumbers: parseInt($event) || null
        });
      } else {
        this.branchesNumbers[index].studentsNumbers = parseInt($event) || null;
      }
    },

    showScopeTreeFn() {
      this.showScopeTree = true;
      this.showBranchesCount = false;
      this.componentKey += 1;
    },

    getApprovalRules(facultyId = null, yearId = null, semesterId = null, certificateId = null) {
      this.loading = true;
      return this.$http
          .post("/api/approval_rules/list_approval_rules/", {
            facultyId: facultyId || "",
            yearId: yearId || this.activeAcademicYear.id || 0,
            semesterId: semesterId || this.activeAcademicSemester.id || 0
          })
          .then(response => {
            const data = response.data.data;
            this.semesters = data.Semesters;
            this.approvalRules = data.approvalRules;
            this.faculties = data.faculties;
            this.CertificateBasicTypes = data.CertificateBasicTypes;
            this.branches = data.branches;
            this.years = data.years;
            this.checkBranches = data.checkBranches
            this.currentYear = this.years.filter(
                year => parseInt(year.active) === 1
            )[0];
            if (!yearId) {
              this.filterItems.yearId = this.currentYear.id || 0;
              this.filterItems.yearName = this.currentYear.name || "";
            } else {
              const year = this.years.find(year => year.id === yearId);
              this.filterItems.yearId = year ? year.id : 0;
              this.filterItems.yearName = year ? year.name : "";
            }

            this.currentSemester = this.semesters.filter(
                semester => parseInt(semester.active) === 1
            )[0];
            if (!semesterId) {
              this.filterItems.semesterId = this.currentSemester.id || 0;
              this.filterItems.semesterName = this.currentSemester.name || "";
            } else {
              const semester = this.semesters.find(
                  semester => semester.id === semesterId
              );
              this.filterItems.semesterId = semester ? semester.id : 0;
              this.filterItems.semesterName = semester ? semester.name : "";
            }
          })
          .then(() => (this.loading = false));
    },

    isNotEmpty(str) {
      return !(!str || 0 === str.length || /^\s*$/.test(str));
    },

    searchApprovalRules() {
      this.getApprovalRules(
          null,
          this.filterItems.yearId,
          this.filterItems.semesterId
      );
    },

    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] === " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },

    save(item) {
      if (parseInt(item.allowedTotalDegree) === 0 || parseInt(item.allowedStudentCount) === 0) {
        this.showToasted("error", this.$t('COMPLETE_DATA_ERROR'))
        return false
      }
      let branchesNumbers = []
      if (this.checkBranches) {
        // edit existing
        if (item.studentsInBranches && item.studentsInBranches.length) {
          branchesNumbers = item.studentsInBranches.map(b => ({
            branchId: b.branchId,
            studentsNumbers: b.studentsNumbers
          }))
        }
      }
      const data = {
        facultyId: item.facultyId,
        certificateId: item.certificateId || null,
        yearId: item.yearId,
        semesterId: item.semesterId,
        totalDegree: item.allowedTotalDegree || null,
        priorityCheck: item.priorityCheck,
        studentsNumbers: parseInt(item.allowedStudentCount) || null,
        branchesNumbers: branchesNumbers
      }

      const request = item.id
          ? this.$http.put(`/api/approval_rules/edit_rule/${item.id}/`, data)
          : this.$http.post("/api/approval_rules/add_rule/", data)

      request.then(
          () => {
            this.showToasted("success")
            item.editable = false
            item.__backup = null
            this.getApprovalRules().then(() => {
              this.normalizeApprovalRules()
            })
          },
          err => {
            this.showAlert = true
            this.errorMessages = this.serverTranslate(err.response.data.message)
            this.showToasted("error", this.errorMessages)
            return false
          }
      )

    },

    editApprovalRule(item) {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "CONFIRMATION_UPDATE_RULE")
          .then(confirm => {
            if (confirm) {

              // اقفل أي صف تاني
              this.approvalRules.forEach(r => r.editable = false)

              // خزن نسخة للـ Cancel (صح)
              item.__backup = {
                allowedTotalDegree: item.allowedTotalDegree,
                allowedStudentCount: item.allowedStudentCount
              }

              // فعل edit لهذا الصف فقط
              item.editable = true
            }
          })
    }

    ,
    resetFilters() {
      this.filterItems = {
        facultyId: 0,
        yearId: 0,
        yearName: "",
        semesterId: 0,
        semesterName: ""
      };

      this.getApprovalRules().then(() => {
        this.normalizeApprovalRules()
      })
    },
    reset() {
      this.dialog = !close;
      this.isAddEvent = true;
      this.showAlert = false;
      this.errorMessages = "";

      this.facultyId = 0;
      this.yearId = 0;
      this.semesterId = 0;
      this.totalDegree = null;
      this.priorityCheck = "1"
      this.studentsNumbers = null;

      this.branchesNumbers = [];
      this.branchesNumbersModel = [];
    },
    onScopeChanged(changed) {
      if (changed)
        this.searchApprovalRules();
    },
    showBranchsTotalCount(item) {
      this.studentsInBranches = this.serverTranslateArray(item.studentsInBranches, "branchName");
      this.showBranchesCount = true;
      this.branchKey += 1;
      this.faculty = this.serverTranslate(item.facultyName);
    }
  },
  watch: {
    'filterItems.yearId'(newId) {
      const selected = this.years.find(y => y.id === newId);
      this.filterItems.yearName = selected ? selected.name : null;
    },
    'filterItems.semesterId'(newId) {
      const selected = this.semesters.find(y => y.id === newId);
      this.filterItems.semesterName = selected ? selected.name : null;
    },
    studentsNumbers(newValue) {
      const totalBranchesNumbers = this.branchesNumbersModel.reduce(
          (a, b) => parseInt(a) + parseInt(b),
          0
      );
      if (newValue >= totalBranchesNumbers) {
        const formInputsRefs = Object.keys(this.$refs);
        formInputsRefs.forEach(input => {
          if ((input || "").startsWith("branchesNumbers")) {
            const inputElement = this.$refs[input][0];
            inputElement.validate();
          }
        });
      }
    }
  }
};


</script>

<style>
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}

table tr th {
  white-space: normal !important;
}

.v-messages__message {
  color: red !important;
}

.editing-row {
  background-color: #f9ffe1 !important; /* لون خفيف */
}
</style>